import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Dashboard from "./pages/Dashboard";
import MyTickets from "./pages/MyTickets";
import CreateTicket from "./pages/CreateTicket";
import EditTicket from "./pages/EditTicket";
import Profile from "./pages/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/layout/Layout";
import MsLoginWrapper from "./configs/MsLoginWrapper";
import ManageCategories from "./pages/ManageCategories";

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  const parsedUser = user ? JSON.parse(user) : user;
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<MsLoginWrapper />} />
        <Route path="/login" element={<MsLoginWrapper />} />
        <Route
          path="/dashboard"
          element={
            parsedUser?.Department === "HR" ||
            parsedUser?.Department === "HRD" ||
            parsedUser?.Department === "Finance" ||
            parsedUser?.Department === "Administration" ||
            parsedUser?.Department === 'Management' ? (
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            ) : (
              <ProtectedRoute>
                <Layout>
                  <MyTickets />
                </Layout>
              </ProtectedRoute>
            )
          }
        />
        <Route
          path="/my-tickets"
          element={
            <ProtectedRoute>
              <Layout>
                <MyTickets />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-ticket"
          element={
            <ProtectedRoute>
              <Layout>
                <CreateTicket />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-ticket/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditTicket />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-categories"
          element={
            <ProtectedRoute>
              <Layout>
                <ManageCategories />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
